import {
    Box,
    TableContainer,
    Table,
    Paper,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Link,
    TextField,
    InputAdornment
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useTsPaginator from 'ts-paginator';
import SearchIcon from '@mui/icons-material/Search';
import { getCbFieldNotes } from '../../../../../../actions/conservation-burns/conservation-burn-actions';
import Paginator from '../../../../../layout/Pagination';

export default function CbFieldNotes() {
    const dispatch = useDispatch()
    // searchQuery is null on initial render to avoid immediate fetch.
    // Turns into a string when user types or backspaces to ''
    const [searchQuery, setSearchQuery] = useState(null);
    const { selectedProject } = useSelector(state => state.postFormData);
    const { id: projectId } = selectedProject || {}
    const cbFieldNotes = useSelector((state) => (state.conservationBurnsReducer.cbFieldNotes?.data))
    const tableRecordCount = useSelector((state) => (state.conservationBurnsReducer.cbFieldNotes?.pagination?.total_records))

    const {
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        // _determinePaginationPages,
        _determineRowsPerPageOptions,
        _handleChangeTotalRecordCount,
        _handleChangeRowsPerPage,
        _handleChangePage,
    } = useTsPaginator(+tableRecordCount || 0, 0)

    useEffect(() => {
        const total = tableRecordCount;
        if (total != null && total !== totalRecordCount) {
            _handleChangeTotalRecordCount(total);
            _handleChangePage(1);
        }
    }, [cbFieldNotes, tableRecordCount]);

    useEffect(() => {
        setSearchQuery(null)
    }, [projectId])

    useEffect(() => {
        dispatch(getCbFieldNotes(projectId, rowsPerPage, currentPage, searchQuery));
    }, [projectId, rowsPerPage, currentPage])

    useEffect(() => {
        if (searchQuery !== null) {
            const timer = setTimeout(() => {
                dispatch(getCbFieldNotes(projectId, rowsPerPage, currentPage, searchQuery));
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [searchQuery, currentPage, rowsPerPage]);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        _handleChangePage(1)
    };

    const fieldNotesColumns = [
        'Project ID',
        'Batch ID',
        'Note Text',
        'Note Photo',
        'Date Added'
    ]

    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                <TextField
                    label="Search Notes"
                    variant="outlined"
                    value={searchQuery || ''}
                    onChange={handleSearchChange}
                    sx={{ width: 400 }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
            <TableContainer component={Paper} sx={{ width: '100%' }}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {fieldNotesColumns.map((column, index) => (
                                <TableCell
                                    key={index}
                                    align={'left'}
                                >
                                    {column}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.isArray(cbFieldNotes) && cbFieldNotes.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell size="small" align="left">
                                    {row.project}
                                </TableCell>
                                <TableCell size="small" align="left">
                                    {row.batch}
                                </TableCell>
                                <TableCell size="small" align="left">
                                    {row.note}
                                </TableCell>
                                <TableCell size="small" align="left">
                                    <Link
                                        href={row.file_url}
                                        target='_blank'
                                        rel="noopener noreferrer"
                                    >
                                        {row.file_name ? row.file_name : 'Photo not available.'}
                                    </Link>
                                </TableCell>
                                <TableCell size="small" align="left">
                                    {row.created_at ? new Date(row.created_at).toLocaleString('en-US', {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    }) : ''}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Paginator
                totalRecordCount={totalRecordCount}
                rowsPerPage={rowsPerPage}
                currentPage={currentPage}
                handleChangePage={_handleChangePage}
                handleChangeRowsPerPage={_handleChangeRowsPerPage}
                determinePaginationMessage={_determinePaginationMessage}
                determinePaginationDisabledState={_determinePaginationDisabledState}
                determineRowsPerPageOptions={_determineRowsPerPageOptions}
            />
        </Box>
    )
}